import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { UserCircle, MenuIcon, HomeIcon, TicketIcon, CreditCardIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigation = [{
    name: 'Dashboard',
    href: '/',
    icon: HomeIcon
  }, {
    name: 'Tickets',
    href: '/tickets',
    icon: TicketIcon
  }, {
    name: 'Reconciliation',
    href: '/reconciliation',
    icon: CreditCardIcon
  }];
  const isActive = path => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-10" data-id="element-72">
      <div className="container mx-auto px-4 md:px-6 lg:px-8" data-id="element-73">
        <div className="flex items-center justify-between h-16" data-id="element-74">
          <div className="flex items-center" data-id="element-75">
            <Link to="/" className="flex items-center" data-id="element-76">
              <h1 className="text-xl font-bold text-blue-600" data-id="element-77">
                Ticketing System
              </h1>
            </Link>
            <div className="hidden md:flex ml-10 space-x-4" data-id="element-78">
              {navigation.map(item => {
              const Icon = item.icon;
              return <Link key={item.name} to={item.href} className={`px-3 py-2 rounded-md text-sm font-medium flex items-center ${isActive(item.href) ? 'text-blue-600 bg-blue-50' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'}`} aria-current={isActive(item.href) ? 'page' : undefined} data-id="element-79">
                    <Icon className="h-4 w-4 mr-1" data-id="element-80" />
                    {item.name}
                  </Link>;
            })}
            </div>
          </div>
          <div className="hidden md:flex items-center" data-id="element-81">
            <div className="flex items-center" data-id="element-82">
              <UserCircle className="h-8 w-8 text-gray-500" data-id="element-83" />
              <span className="ml-2 text-sm font-medium text-gray-700" data-id="element-84">
                John Doe
              </span>
            </div>
          </div>
          <div className="md:hidden" data-id="element-85">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="p-2 rounded-md text-gray-500 hover:text-gray-700 focus:outline-none" aria-expanded={isMenuOpen} aria-label="Open main menu" data-id="element-86">
              <MenuIcon className="h-6 w-6" data-id="element-87" />
            </button>
          </div>
        </div>
        {isMenuOpen && <div className="md:hidden py-2 border-t border-gray-200" data-id="element-88">
            <div className="px-2 pt-2 pb-3 space-y-1" data-id="element-89">
              {navigation.map(item => {
            const Icon = item.icon;
            return <Link key={item.name} to={item.href} className={`block px-3 py-2 rounded-md text-base font-medium flex items-center ${isActive(item.href) ? 'text-blue-600 bg-blue-50' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'}`} aria-current={isActive(item.href) ? 'page' : undefined} data-id="element-90">
                    <Icon className="h-5 w-5 mr-2" data-id="element-91" />
                    {item.name}
                  </Link>;
          })}
            </div>
            <div className="pt-4 pb-3 border-t border-gray-200" data-id="element-92">
              <div className="flex items-center px-5" data-id="element-93">
                <div className="flex-shrink-0" data-id="element-94">
                  <UserCircle className="h-10 w-10 text-gray-500" data-id="element-95" />
                </div>
                <div className="ml-3" data-id="element-96">
                  <div className="text-base font-medium text-gray-800" data-id="element-97">
                    John Doe
                  </div>
                  <div className="text-sm font-medium text-gray-500" data-id="element-98">
                    john@example.com
                  </div>
                </div>
              </div>
            </div>
          </div>}
      </div>
    </header>;
};
export default Header;